// src/components/Services.jsx
import React, { useState } from "react";
import "./Services.css";

const ImageModal = ({ src, alt, onClose }) => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.7)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    }}
    onClick={onClose}
  >
    <img
      src={src}
      alt={alt}
      style={{
        maxWidth: "90vw",
        maxHeight: "90vh",
        borderRadius: "12px",
        boxShadow: "0 2px 16px rgba(0,0,0,0.5)",
        background: "#fff",
      }}
      onClick={e => e.stopPropagation()}
    />
  </div>
);

const services1 = [
  {
    title1: "Dance Movement Therapy",
    description1:"Man moves in search of meaning – Rudolf Laban. Indeed, movement is our universal language. It psychotherapeutic use of movement as a process, which furthers the emotional, social, cognitive, & physical integration of the individual. It utilizes spontaneous dance and free movement rather than teaching the dance techniques into the therapy sessions. If you think you have two left feet and have history of trauma, I think you should really explore Dance Movement Therapy for the integration of your body, mind and spirit.",
    image1: "./Services Dance Movement Therapy1.jpg",
  },
  {
    title1: "Gestalt Psychotherapy",
    description1:"If you want to enhance your awareness and have the hands-on experiential to healing, then you can give yourself the permission to book Gestalt Psychotherapy with me. I as the Gestalt Psychotherapist believe, everyone is capable of responding and so you are. Gestalt emphasizes personal responsibility, and focuses upon the individual's experience in the present moment. ‘Awareness leads to change’, let’s stay in contact with the therapeutic relationship to delve into the creative experimentation and work on our awareness to foster healing, become more fully and creatively alive and free from the blocks and unfinished business that may diminish satisfaction, fulfilment, and growth. Give yourself the gift of new ways of being with the harvest of mindful experimentation. ",
    image1: "./Services Gestalt Psychotherapy.jpeg",
  },
  {
    title1: "Counseling Supervision",
    description1:"Being a counsellor and psychotherapist is not always full of pleasantries. No wonders that this profession adds beauty in your life being able to support people in mental health problems. But it also makes your stuck and helpless with locked doors of sharing this feeling due to professional/ethical reasons. That’s why, I offer supervision sessions to offer normative, formative and restorative functions. My supervision sessions could be both individual and groups. You can choose the modality of your own for regular guidance and mentoring. ",
    image1: "./Services Counseling Supervision.jpg",
  },
  {
    title1: "Individual / Group Counseling",
    description1:"Individual counselling is personal opportunity to receive support and experience growth during challenging times in life. It is usually person to person with the involvement of people in relationship in case of need.I offer individual counselling to adolescents and adults. My sessions help clients to understand and clarify their views of their life space, and to learn to reach their self-determined goals through meaningful, well-informed choices. \n\n Group counselling involves meeting with group of individuals having similar issues to share their experiences and listen to others experiences. It provides a supportive environment to discuss problems and concerns and work towards their goals.I offer short-term and long term, open and closed groups. I usually run self-care groups named ‘Nourish to Flourish’, groups for grief, groups for sex abuse survivors, LGBTQIA+ groups. ",
    image1: "./Services Individual Session.png",
  },
  {
    title1: "Couple Counseling",
    description1:"Do you want to improve your relationship with your partner and help each other in recognizing and resolving conflict. You should surely book my couple counselling. My couple counselling is for both married and unmarried couples who look forward to rebuilding and strengthening their relationship and gain better understanding of each other’s need. I believe most of the couples have relationship issues for not being able to talk about their needs and expectations from their partners. ",
    image1: "./Services Couple Counseling.jpg",
  },
  {
    title1: "Training & Workshops",
    description1: "Trainings and workshops are the gateways to empower ourselves to unleash an individual’s fullest potential. I offer trainings and workshops like Psychosocial Counselling, Self-care, School Mental Health, Mental Health in Corporate sector, Emotion regulation in hospitality sector, Yog, Tibetan Sound healing etc. Moreover, in academic settings, I find trainings in counselling, psychotherapy and counselling supervision very interesting. Alongside these, I believe in the concept of holistic well-being. So, incorporating alternative healing modalities like Yog, Reiki, Sound healing in my practice is very significant and I train enthusiasts in sound healing and Yog as well.\n\n Feel free to reach out to me for the trainings and workshops.",
    image1: "./Services Training2 (1).jpg",
  },
];

const services2 = [
  {
    title2: "Reiki Healing",
    description2:"Reiki is magical hands - on healing modality rediscovered by Mikao Usui in Japan. It is one of my self -care tool to destress myself and work on physical, mental, emotional and spiritual healing. I believe it is not a treatment method rather it is complimentary technique that works in conjunction with all other medical or therapeutic techniques to promote recovery. It has been found effective in alleviating issues like pain, stress, job bur out, anxiety, depression, chronic health conditions and for improving self-esteem and quality of life (McManus, 2017). I incorporate reiki in my other services to promote natural healing abilities of an individual. ",
    image2: "./Services Reiki Healing.jpg",
  },
  {
    title2: "Tibetan Sound Healing",
    description2:"‘Everything in life is vibration’, mentions Albert Einstein, everything including our bodies. When these vibrations are disrupted, it can lead to physical or emotional imbalance. Sound healing uses sound frequencies that induces a meditative state, reduces stress, harmonizes the body and mind which eventually promotes healing. In my sound healing sessions, I use Tibetan singing bowls, gongs, tingsha, tuning forks, mantra chanting and different hand gestures (Hasta Mudras). I offer both individual sound healing sessions, group sound bath and equine assisted sound healing. ",
    image2: "./Services Sound Healing.jpg",
  },
];

const services3 = [
  {
    title3: "Yog Teacher's Training (USA Yog Alliance Accreditation)",
    description3:"(RYT  200 / RYT 300 & RYT 500) Hrs Teacher’s Training Program (USA Alliance Accredited) are my offerings. I practice Ashtanga Vinayasa Style. There are three paths to choose from, depending on your experience level and goals. Each program weaves in Ashtanga Vinyasa, Hatha Flow, Pranayama, Yog Anatomy, Philosophy, Yogic detoxification, teaching methodology and so on. It is intended for people who would like to take Yog to the next level, make career and learn, earn and grow in the field of Yog.\n\nFor more information, please check Nirvana Yogalaya (Yog Teacher’s Training (USA Yoga Alliance–Accredited) – Nirvana Yogalaya)",
    image3: "./Services Yoga1.jpg",
  },
  {
    title3: "Yog for Mental Health",
    description3: "Yog for Mental Health is everyday Yog that I offer it to people for the promotion of mental health and holistic well-being. It includes Yog asanas, Pranayama, Meditation, Yogic detoxification and disease specific Yog. Moreover, yog for children and adolescents is another highlight of this program.\n\nHope to see you or your children in this program. For more information check Nirvana Yogalaya (Regular Yog Class – Nirvana Yogalaya )",
    image3: "./Services Yoga for Mental Health1.jpg",
  },
];


const SeeMoreText = ({ text, limit = 135 }) => {
  const [expanded, setExpanded] = useState(false);
  const isLong = text.length > limit;

  // Replace Nirvana Yogalaya references with a link
  const linkified = para =>
    para.replace(
      /(Nirvana Yogalaya)/g,
      `<a href="https://nirvanayogalaya.org" target="_blank" rel="noopener noreferrer" style="color:#376756;text-decoration:underline;">$1</a>`
    );

  const paragraphs = text.split("\n\n");

  return (
    <>
      {expanded ? (
        paragraphs.map((para, i) => (
          <p key={i} dangerouslySetInnerHTML={{ __html: linkified(para) }} />
        ))
      ) : (
        <p
          dangerouslySetInnerHTML={{
            __html: linkified(text.slice(0, limit) + (isLong ? "..." : "")),
          }}
        />
      )}
      {isLong && (
        <button
          onClick={() => setExpanded(!expanded)}
          style={{
            color: "#376756",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            textDecoration: "underline",
          }}
        >
          {expanded ? "See Less" : "See More"}
        </button>
      )}
    </>
  );
};


const Services = () => {
  const [modalImg, setModalImg] = useState(null);

  const handleImgClick = (src, alt) => {
    setModalImg({ src, alt });
  };

  const closeModal = () => setModalImg(null);

  return (
    <section id="services" className="services-section">
      {modalImg && (
        <ImageModal src={modalImg.src} alt={modalImg.alt} onClose={closeModal} />
      )}
      <h2>Mental Health Services</h2>
      <div className="services-grid">
        {services1.map((service, idx) => (
          <div key={idx} className="service-card">
            <div className="service-icon"></div>
            <div>
              <h3>{service.title1}</h3>
              <SeeMoreText text={service.description1} />
            </div>
            <img
              src={service.image1}
              className="service-img"
              alt="Mental Health Service"
              style={{ cursor: "pointer" }}
              onClick={() => handleImgClick(service.image1, service.title1)}
            />
          </div>
        ))}
      </div>

      <h2>Alternative Healing Modalities</h2>
      <div className="services-grid">
        {services2.map((service, idx) => (
          <div key={idx} className="service-card">
            <div className="service-icon"></div>
            <div>
              <h3>{service.title2}</h3>
              <SeeMoreText text={service.description2} />
            </div>
            <img
              src={service.image2}
              className="service-img"
              alt="Alternative Healing Modality"
              style={{ cursor: "pointer" }}
              onClick={() => handleImgClick(service.image2, service.title2)}
            />
          </div>
        ))}
      </div>

      <h2 id="yoga-classes">Yog Classes</h2>
      <div className="services-grid">
        {services3.map((service, idx) => (
          <div key={idx} className="service-card">
            <div className="service-icon"></div>
            <div>
              <h3>{service.title3}</h3>
              <SeeMoreText text={service.description3} />
            </div>
            <img
              src={service.image3}
              className="service-img"
              alt="Yoga Class"
              style={{ cursor: "pointer" }}
              onClick={() => handleImgClick(service.image3, service.title3)}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
